import { render, staticRenderFns } from "./OfferPremiumInfoPropertyAllRisks.vue?vue&type=template&id=18649dca"
import script from "./OfferPremiumInfoPropertyAllRisks.vue?vue&type=script&lang=js"
export * from "./OfferPremiumInfoPropertyAllRisks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports